import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { trackPageView } from "../analytics";

/** Sends GA4 page_view on every React Router navigation. */
function AnalyticsRouteListener (): null {
  const location = useLocation();
  const isFirst = useRef(true);

  useEffect(() => {
    // Initial view is sent from gtag script onload to avoid a double hit
    // before the library is ready.
    if (isFirst.current) {
      isFirst.current = false;
      return;
    }
    trackPageView(`${location.pathname}${location.search}`, document.title);
  }, [location.pathname, location.search]);

  return null;
}

export default AnalyticsRouteListener;
